import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import "./DataEngineeringContent.css";
import DataEngineeringLevelTabs from "./DataEngineeringLevelTabs";
import AOS from "aos";
import "aos/dist/aos.css";
import { useMsal } from "@azure/msal-react";
import FullStackEnginnerLevelTabs from "./FullStackEnginnerLevelTabs";
// import DataEngineeringFoundTrack from "./DataEngineeringFoundTrack";

function SolutionArchitectContent({bannerimg}) {
  const [username, setUsername] = React.useState();
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [level, setLevel] = useState("");
  const [proficiency, setProficiency] = useState("");

  useEffect(() => {
    if (activeAccount) setUsername(activeAccount.idTokenClaims.enterpriseID);
  }, [activeAccount]);
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <>
      <div className="main-banner">
        <img
          src={bannerimg}
          alt="banner"
          className="banner-img"
        />
        {/* <div className="domain-role-sec">
          <p>
            Domain: <span>E&E</span>{" "}
          </p>
          <p>
            Role: <span>Data Engineering</span>
            <br /> <span className="profici-level">({proficiency})</span>{" "}
          </p>
        </div> */}
      </div>
      <div className="data-engineering-sec">
        <div className="data-engineering-wrap">
          <ul className="breadcrumbs">
            <li className="breadcrumbs-item">
              <NavLink
                activeClassName="is-active"
                className="breadcrumbs-links"
                to="/home"
              >
                Home
              </NavLink>
              <span>
                <FiChevronRight />
              </span>
            </li>
            <li className="breadcrumbs-item">
              <a
                activeClassName="is-active"
                className="breadcrumbs-links"
                href="/VodafoneTalentAcademy/home#Roles"
              >
                Roles
              </a>
              <span>
                <FiChevronRight />
              </span>
            </li>
            {/* <li className="breadcrumbs-item">
       <NavLink activeClassName="is-active" className="breadcrumbs-links" to="/Domains">
        Role-based Learning
       </NavLink>
       <span>
        <FiChevronRight />
       </span>
      </li> */}
            <li className="breadcrumbs-item">
              <NavLink
                activeClassName="is-active"
                className="breadcrumbs-links"
                to="/DataEngineering"
              >
                Full Stack Engineering
              </NavLink>
            </li>
          </ul>
          <div className="about-data-engi-container">
            <div className="about-data-engi-wrap">
              <h2>About Full Stack Engineer</h2>
              <p>
                Embark on a journey of technological mastery with Full Stack
                Engineering, a discipline that seamlessly blends front-end and
                back-end development. As a Full Stack Engineer, you become the
                architect of digital experiences, proficient in both client and
                server-side technologies.{" "}
                <p>
                  From crafting immersive user interfaces to optimizing database
                  performance, this skill set empowers you to navigate the
                  entire software development lifecycle, creating robust and
                  dynamic applications that define the future of digital
                  innovation.
                </p>
              </p>
              {/* <p>
                Full Stack Engineers are the masterminds who craft the pathways
                for data to flow seamlessly. They design the pipelines,
                transforming raw data into meaningful insights, making sure
                information is secure, and readily accessible.
              </p> */}
            </div>
          </div>
          <div className="prog-obj-sec">
            <div className="prog-obj-wrap">
              <h2>Instructions</h2>
              <ul>
                <li>Time limit for the assessment will be 85 minutes</li>
                <li>
                  You will be logged off if you navigate away from the
                  assessment window and you need to take the assessment again
                </li>
                <li>
                  Please make sure that you complete the test in a single go.
                  You will not be allowed to save partial assessment and take it
                  later
                </li>
                <li>Please submit offline code snippet along with the test.</li>
                <li>
                  Internet: You must have a stable 2Mbps of Upload & Download
                  speed.Please use Broadband. Avoid using unstable 3G/4G
                  Networks
                </li>
                <li>Make sure that your phone is away and on silent mode</li>
                <li>
                  Make sure that your laptop/desktop is connected to the power
                  supply and/or UPS
                </li>
                <li>Only use Laptop/Desktop. DO NOT use Mobile/Tablet</li>
                <li>Make sure you submit the test once you complete</li>
              </ul>
              {/* <h2>Program Objectives</h2>
              <ul>
                <li>
                  <span> Data Pipeline Development:</span> Equip students with
                  the skills to design, build, and maintain data pipelines that
                  collect, process, and store data efficiently.
                </li>
                <li>
                  <span>Data Integration:</span> Teach methods to integrate data
                  from various sources, ensuring consistency and quality for
                  analytics and reporting.
                </li>
                <li>
                  <span> Database Management:</span> Provide knowledge in
                  managing and optimizing databases, both relational and NoSQL,
                  to store and retrieve data effectively.
                </li>
                <li>
                  <span>Big Data Technologies:</span> Familiarize learners with
                  big data tools and frameworks like Hadoop, Spark, and Kafka to
                  handle large datasets and real-time processing.
                </li>
              </ul> */}
              <div className="prog-obj-row">
                <div className="prog-obj-box">
                  <h3>To know your Proficiency Level</h3>
                  <p>
                    <a
                      href="https://deepknowledge.accenture.com/course/view.php?id=1444"
                      // target="_blank"
                    >
                      <button
                        className="assess-disable-btn"
                        // disabled={
                        //   (userProficiency != undefined &&
                        //     userProficiency.length != 0) ||
                        //   count > 2
                        //     ? true
                        //     : false
                        // }
                        // onClick={() => {
                        //   openPreassessmentWindow("preassessment");
                        // }}
                      >
                        Take Pre-assessment{" "}
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/DataEngineering/hand-icon.png"
                          }
                          //src="images/DataEngineering/hand-icon.png"
                          alt="hand-icon"
                          className="hand-icon"
                        />{" "}
                      </button>
                    </a>
                  </p>
                </div>
              </div>
              <div className="assessments-wrap">
                {/* {AssessmentsData.map((item) => {
                  return (
                    <div
                      key={item.id}
                      className={
                        item.level == level
                          ? "assessments-row"
                          : "assessments-row inactive"
                      }
                    >
                      <button
                        className="level-disable-btn"
                        // disabled={item.level == level ? false : true}
                        // onClick={() => {
                        //   openPreassessmentWindow(item.level);
                        // }}
                      >
                        <div className="assessments-box">
                          <h3>{item.assessmentname}</h3>
                          <p>({item.assessmentlevel})</p>
                        </div>
                      </button>
                    </div>
                  );
                })} */}
              </div>
            </div>
          </div>
          <div className="data-engi-level-sec">
            <div className="data-engi-level-wrap">
              {/* <DataEngineeringLevelTabs /> */}
              <FullStackEnginnerLevelTabs />
            </div>
          </div>

          {/* fourth section */}
          {/* <div className="foundation-track-sec">
      <div className="foundation-track-wrap">
       <h2>Data Engineering Foundation Track</h2>
       <p>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Repellendus laboriosam
        esse, omnis in, consequatur animi maiores maxime nisi cupiditate libero
        repudiandae voluptates accusantium id architecto nihil est beatae commodi
        doloribus?
       </p>
       <DataEngineeringFoundTrack />
      </div>
     </div> */}
        </div>
      </div>
    </>
  );
}

export default SolutionArchitectContent;
